import { useAppContext } from '@/components/utilities/AppContext';

// Ebook UI labels. Unlike the glossary, the ebook section has no Strapi settings
// single-type — the label set is small and fixed, so defaults live here per locale.
export const EBOOK_LABELS = {
  cs: {
    homeLabel: 'Domů',
    breadcrumbAriaLabel: 'Navigace',
    heroEyebrow: 'Průvodce',
    tocTitle: 'Obsah průvodce',
    furtherReadingTitle: 'Další zdroje ke studiu',
    newsletterPlaceholder: 'Váš e-mail',
    newsletterButtonLabel: 'Přihlásit se',
    newsletterSubmittedText: 'Děkujeme! Máte to.'
  },
  pl: {
    homeLabel: 'Strona główna',
    breadcrumbAriaLabel: 'Nawigacja',
    heroEyebrow: 'Przewodnik',
    tocTitle: 'Spis treści przewodnika',
    furtherReadingTitle: 'Dodatkowe materiały',
    newsletterPlaceholder: 'Twój e-mail',
    newsletterButtonLabel: 'Zapisz się',
    newsletterSubmittedText: 'Dziękujemy! Gotowe.'
  }
};

export const getEbookLabels = (locale) => (locale !== 'pl' ? EBOOK_LABELS.cs : EBOOK_LABELS.pl);

export const useEbookLabels = () => {
  const { locale } = useAppContext();
  return getEbookLabels(locale);
};
